// extracted by mini-css-extract-plugin
export default {"centered":"HomeView_centered__Chlyn","idInput":"HomeView_idInput__qcy0g"};